// Package Imports
import { Col, Row } from 'antd';

import DMNViewer from 'pages/rules/DMNViewer';
import RuleConfiguration from 'pages/rules/ruleConfiguration';
import classNames from 'core/utils/classNames';
import { useRulesCreateState } from 'pages/rules/context/RulesCreateStateContext';

export const ruleTypeItem = (
  fileType,
  defaultFileListObj,
  uploadType,
  form,
  type,
  clawbackType
) => {
  const state = useRulesCreateState();
  let message;
  if (state.hasInvalidOutputColumn) {
    message =
      'Invalid Output Column : Output Column should match with unified columns';
  } else if (state.hasInvalidInputColumn) {
    message =
      'Invalid Input Column : Input Column should match with unified columns';
  }
  const scrollToDiv = () => {
    const element = document.getElementById('scrollDmn');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="">
      <Row>
        <Col xs={24} sm={24} lg={24}>
          <DMNViewer
            defaultFileListObj={defaultFileListObj}
            form={form}
            message={message}
            fileType={fileType}
            type={type}
            clawbackType={clawbackType}
          />
          {state.dmnErrors.length > 0 ? (
            <div
              className="dmn-error mx-auto max-w-3xl bg-white rounded-lg border border-gray-300"
              onClick={scrollToDiv}
            >
              <h4 className="text-lg text-center font-semibold text-red-600 mb-4">
                Error: Failed to validate DMN data
              </h4>
              <table className="min-w-full table-auto text-center border-gray-300">
                <thead>
                  <tr className="bg-primary text-white">
                    <th className="px-4 py-2 font-semibold rounded-tl-lg">
                      Row
                    </th>
                    <th className="px-4 py-2 font-semibold th-border">
                      Column
                    </th>
                    <th className="px-4 py-2 font-semibold th-border">Value</th>
                    <th className="px-4 py-2 font-semibold rounded-tr-lg">
                      Error
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {state.dmnErrors.map((error, index) => (
                    <tr key={index}>
                      <td className="border px-4 py-2">{error.row}</td>
                      <td className="border px-4 py-2">{error.col}</td>
                      <td className="border px-4 py-2">{error.value}</td>
                      <td className="border px-4 py-2">{error.error}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

export const ruleOutputItem = () => {
  const state = useRulesCreateState();
  return (
    <div
      className={`$${
        state.inputSourceFileData === undefined
          ? 'rule-config-card mt-6 mb-12'
          : 'mt-6 mb-12'
      }`}
    >
      {state.inputSourceFileData === undefined ||
      state.hasInvalidOutputColumn ? (
        <p
          className={classNames(
            'text-lg text-center font-semibold pb-4',
            state.hasInvalidOutputColumn ? 'text-red-500' : 'text-black'
          )}
        >
          {state.hasInvalidOutputColumn
            ? 'Invalid Output Column : Output Column should match with unified columns'
            : 'Please configure the rule.'}
        </p>
      ) : (
        <Row>
          <Col xs={24} sm={24} lg={18}>
            <RuleConfiguration
              outputValue={state.outputValue}
              type={state.pageType}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};
